export default __webpack_public_path__ + "static/media/hiring-200px.eacc647b.svg";